import Api from '../../shared/Api';

class FavoriteImagesApi {
    static getFavoriteImages(page: number, photographerId?: number): any {
        return new Api().get(`/views/favorited-photo`, { page, photographerId });
    }

    static getPhotographers(): any {
        return new Api().get(`/views/favorited-photo/photographers`);
    }

    static getFavoriteImage(id): any {
        return new Api().get(`/views/favorited-photo/${id}`);
    }

    static removeFavoriteImage(derivedOrderId, photoId) {
        return new Api().delete(
            `/views/orders/${derivedOrderId}/imageprocessing/${photoId}/favorite/remove`
        );
    }
}

export default FavoriteImagesApi;
